import React, { useContext, useEffect, useState } from "react";
import {observer} from "mobx-react-lite";
import {Context} from "..";
import { getAllFilters } from "../http/productAPI";
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import ProductList from "../components/ProductList";
import '../components/FrontProductsBlock.css';
import { promotionMetaByName } from "../utils/promotionUtils";
import { useProductsLoader } from "../hooks/useProductsLoader";



const PromotionsPage = observer(({ categories }) => {
  const navigate = useNavigate();
  const { product } = useContext(Context);
  const [filtersFromURLLoaded, setFiltersFromURLLoaded] = useState(false); // что бы не запрашивались 2 раза по типу loading
  

    useEffect(() => {
              // ОБЯЗАТЕЛЬНО ВНУТРИ useEffect              
              product.setSelectedFilters({"Товары со скидкой": ["true"]});
              product.setSelectedFolder({ id: "2" });
              getAllFilters(product.selectedFolder.id).then(data => {
                  product.setFilters(data);
                  setFiltersFromURLLoaded(true); // запускаем useProductsLoader
                });
          }, []); // Выполнится один раз при монтировании

//  не работает перерендер... при изменении viewAsManager
/*    useEffect(() => {
        getProducts(product.selectedFolder.id, 0, 40, selectedFolderFilters).then(data => {
            product.setProducts(data.products);
            product.setFilters(data.filters);
                         if (user.viewAsManager) {
                    const productIds = data.products.map((p) => p.id);
            
                    // import { getProducts, getWholesalePrices } from "../../http/productAPI";  
                    // const { user, product } = useContext(Context);
             try {
                      getWholesalePrices(productIds)
                        .then(optPrices  => { 
                      // 💡 Например, сохраним отдельно
                      // product.setWholesalePrices(wholesalePrices);
                      // или обновим продукты с оптовыми ценами
                       product.setProducts(
                         data.products.map((p) => ({
                           ...p,
                           optPrice: optPrices.find((w) => w.id === p.id)?.optPrice,
                         })
                        )
                       )});
                    } catch (err) {
                      console.error("Ошибка при получении оптовых цен:", err);
                    }
                  }
        })
        .catch(error => {
            console.log("Ошибка при получении продуктов: SubCatalogList useEffect", error);
        });
      }, [user.viewAsManager ])*/
  useProductsLoader(filtersFromURLLoaded);

  return (
    <div className="py-4">
    <Container className="py-5">
      <h1 className="mb-4 text-center">Актуальные акции</h1>
      {filtersFromURLLoaded && (
          <Row>
            {product.filters
              .filter(f => f.order >= 13 && promotionMetaByName[f.name])
              .map((filter, idx) => {
                const { key, image, description } = promotionMetaByName[filter.name];
              
                return (
                  <Col key={idx} md={6} lg={4} className="mb-4">
                    <Card
                      onClick={() => navigate(`/catalog/wall_split_system?${key}`)}                 
                      className="h-100 shadow-sm promo-card"
                      style={{ cursor: 'pointer' }}
                    >
                      <Card.Img
                        variant="top"
                        src={require(`../assets/img/${image}`)}
                        alt={filter.name}
                        style={{ height: '200px', objectFit: 'cover' }}
                      />
                      <Card.Body>
                        <Card.Title>{filter.name}</Card.Title>
                        <Card.Text>{description}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
          </Row>
      )}        

    </Container>

    
    <ProductList/>                  
     
     </div>
  );
});

export default PromotionsPage;
